var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypicalDensities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-1",
    d: "M8.71 20a8 8 0 0 0 10.58 0 8 8 0 0 0-10.58 0Zm-1-10.9A8 8 0 0 0 6.06 13H7a1 1 0 0 1 0 2h-.94a8 8 0 0 0 1.32 3.5A10 10 0 0 1 13 16v-5a1 1 0 0 1 2 0v5a10 10 0 0 1 5.62 2.45A8 8 0 0 0 21.94 15H21a1 1 0 0 1 0-2h.94a8 8 0 0 0-1.62-3.9l-.66.66a1.004 1.004 0 0 1-1.42-1.42l.67-.66A8 8 0 0 0 15 6.06V7a1 1 0 0 1-2 0v-.94a7.9 7.9 0 0 0-3.9 1.62l.66.66a1.004 1.004 0 1 1-1.42 1.42l-.66-.67ZM14 24a10 10 0 1 1 10-10 10 10 0 0 1-10 10Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-1",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    id: "g16",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path)"
    },
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)",
    id: "g14",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1
    },
    d: "M-1-1h30v30H-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypicalDensities);
export default __webpack_public_path__ + "static/media/typical-densities.3b0a8329dd49bd557951b4fc278af532.svg";
export { ForwardRef as ReactComponent };